/*eslint-disable array-callback-return */
import { SearchSVG } from 'src/Admin/img/GlobalSVG';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';
//import MasterPermissions from 'src/Admin/api/MasterPermissions';
export const ServiceCodeNameSearch = ({
  options,
  coverageTypes,
  activeCoverageType,
  onChange,
  value,
}) => {
  console.log('CoverageTypeFilter coverageTypes', coverageTypes);

  return (
    <AutoSuggestionSelectComponent
      options={options}
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator: () => (
          <span style={{ marginLeft: '10px' }}>
            <SearchSVG.SearchSVG className="primary-text-color" />
          </span>
        ),
      }}
      inputClassName="accumulator-code-search-filter height-32 d-inline"
      //value={{ label: activeCoverageType, value: activeCoverageType }}
      value={value}
      onChange={(e) => {
        onChange(e);
      }}
      placeholder={'By Service Name or Code'}
    />
  );
};
